import { render } from "./iframePopUp.vue?vue&type=template&id=44a9d2ce&ts=true"
import script from "./iframePopUp.vue?vue&type=script&lang=ts"
export * from "./iframePopUp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__